import {Directive} from '@angular/core';

@Directive({
  selector: '[appParameterTemplate]'
})
export class ParameterTemplateDirective {
}
